<!-- Controls -->
@if (viewModeConfig()) {
  <div class="controls-section mb-3">
    <zag-card-view-controls
      [config]="viewModeConfig()!"
      [viewState]="viewState()"
      (viewModeChange)="onViewModeChange($event)"
      (sortChange)="onSortChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    >
    </zag-card-view-controls>
  </div>
}

<!-- Card View (only show if in card mode) -->
@if (isCardMode()) {
  <zag-generic-card-view
    [data]="sortedData"
    [config]="cardConfig()"
    [pageSize]="viewState().pageSize || 0"
    [loading]="loading()"
    (cardClick)="onCardClick($event)"
  >
  </zag-generic-card-view>
} @else {
  <!-- Slot for alternative view (grid, chart, etc.) -->
  <div class="alternative-view">
    <ng-content></ng-content>
  </div>
}
